import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@mui/styles";
import { withRouter } from "react-router-dom";
import "../../statusIcon.css";
import { getGpsPosition, gpsPositionError, getDefaultPosition } from "../../redux/gps/gpsActions";
import { loadIntervention, getStartedWorkOrder } from "../../redux/intervention/interventionActions";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../ListDetail.css";
import { formatStatus } from "../../redux/intervention/interventionStatusActions";
import { getColorFromStatusLabel } from "../../redux/intervention/interventionStatusActions";
import { startIntervention, pauseIntervention } from "../../redux/intervention/interventionEditionActions";
import StartInterventionModal from "./StartInterventionModal";
import { loadCurrentTimeSlot } from "../../redux/imputationInterventionRel/imputationInterventionRelActions";
import Icon from "@mui/material/Icon/Icon";
import ComponentsParkIcon from "../../images/components_park_orange.png";
import WorkerIcon from "../../images/worker-hat-icon.png";
import Button from "@mui/material/Button";
import InterventionStatusIcon from "./InterventionStatusIcon";
import CardActions from "@mui/material/CardActions";
import Tooltip from "@mui/material/Tooltip";
import InterventionAlreadyInProgressModal from "./InterventionAlreadyInProgressModal";
import { throwWarning } from "../../lib/error_helper";
import { getStateAccessor } from "../../lib/evaluateStringAsCodeHelper";
import { removeIntervention } from "../../redux/intervention/interventionEditionActions";
import { getCurrentFunctionName } from "../../performanceModeManager";
import { MenuItem, Menu } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { clone } from "../../utils";

const styles = {
	cardActions: {
		padding: 1,
		width: "100%",
		display: "flex",
		flexDirection: "row-reverse",
		justifyContent: "space-between",
		marginTop: "10px",
		paddingLeft: "15px",
	},
	smallButton: {
		width: "130px",
		margin: "0 20px 0 0",
		padding: 0,
	},
	icon: {
		fontSize: 18,
	},
	btnGo: {
		maxHeight: "35px",
	},
};

class InterventionListDetail extends Component {
	constructor(props) {
		super(props);

		this.state = {
			startInterventionModalOpenned: false,
			pauseInterventionModalOpenned: false,
			interventionToPause: null,
			anchorEl: null,
			displayContextMenu: false,
		};

		this.handleButtonPress = this.handleButtonPress.bind(this, this.props.intervention);
		this.handleButtonRelease = this.handleButtonRelease.bind(this);
	}

	shouldComponentUpdate(nextProps, nextState) {
		let startInterventionModalOpennedChange =
			this.state.startInterventionModalOpenned !== nextState.startInterventionModalOpenned;
		let pauseInterventionModalOpennedChange =
			this.state.pauseInterventionModalOpenned !== nextState.pauseInterventionModalOpenned;
		let interventionToPauseChange = this.state.interventionToPause !== nextState.interventionToPause;
		let displayContextMenuChange = this.state.displayContextMenu !== nextState.displayContextMenu;
		let anchorElChange = this.state.anchorEl !== nextState.anchorEl;
		let gpsInProgressChange = this.props.geolocalisationInProgress !== nextProps.geolocalisationInProgress;
		let interventionStatusChange =
			this.props.intervention.state !== nextProps.intervention.state ||
			this.props.intervention.internalState !== nextProps.intervention.internalState;
		let interventionIdChange = this.props.intervention.id !== nextProps.intervention.id;

		return (
			startInterventionModalOpennedChange ||
			pauseInterventionModalOpennedChange ||
			interventionStatusChange ||
			interventionToPauseChange ||
			displayContextMenuChange ||
			anchorElChange ||
			gpsInProgressChange ||
			interventionIdChange
		);
	}

	componentDidMount() {
		if (navigator.geolocation) this.props.getGpsPosition.bind(this.props.authorizedApps);

		this.divRef.addEventListener("touchstart", this.handleButtonPress, {
			passive: true,
		});
		this.divRef.addEventListener("mousedown", this.handleButtonPress, {
			passive: true,
		});
		this.divRef.addEventListener("touchend", this.handleButtonRelease, {
			passive: true,
		});
		this.divRef.addEventListener("mouseup", this.handleButtonRelease, {
			passive: true,
		});
		this.divRef.addEventListener("mouseleave", this.handleButtonRelease, {
			passive: true,
		});
	}

	componentWillUnmount() {
		this.divRef.removeEventListener("touchstart", this.handleButtonPress, {
			passive: true,
		});
		this.divRef.removeEventListener("mousedown", this.handleButtonPress, {
			passive: true,
		});
		this.divRef.removeEventListener("touchend", this.handleButtonRelease, {
			passive: true,
		});
		this.divRef.removeEventListener("mouseup", this.handleButtonRelease, {
			passive: true,
		});
		this.divRef.removeEventListener("mouseleave", this.handleButtonRelease, {
			passive: true,
		});
	}

	handleButtonPress(intervention, event) {
		let target = event.currentTarget;
		this.buttonPressTimer = setTimeout(() => {
			this.setState({ anchorEl: target });
			this.openContextMenu(intervention);
		}, 3000);
	}

	handleButtonRelease() {
		clearTimeout(this.buttonPressTimer);
	}

	displayIntervention() {
		this.props.loadIntervention(this.props.intervention);
		this.props.history.push("/interventions/intervention");
		this.props.globalContainer.current.scrollTop = 0;
	}

	launchMaps() {
		let address;

		if (this.props.intervention.delivery_address_id) address = this.props.intervention.delivery_address_id;
		else address = this.props.intervention.delivery_customer_id;

		if (!address) return;

		let strAddress = address.street.concat(address.zip).concat(" ").concat(address.city);

		let uri = "geo:?q=";
		uri = uri.concat(encodeURIComponent(strAddress));
		window.open(uri);
	}

	start(startDate, startTime) {
		this.pauseInterventionInProgress(startDate, startTime).then((interventionIsInProgress) => {
			if (interventionIsInProgress) return;

			if (this.state.startInterventionModalOpenned && startDate) {
				let gpsPosition = getDefaultPosition();
				if (this.props.gpsPosition && this.props.gpsPosition.coords)
					gpsPosition = {
						lat: this.props.gpsPosition.coords.latitude,
						lon: this.props.gpsPosition.coords.longitude,
					};

				let imputationInformations = {
					startDate: startDate,
					startTime: startTime,
					currentDay: this.props.currentDay,
					gpsPosition: gpsPosition,
				};

				this.props.startIntervention(
					this.props.intervention,
					imputationInformations,
					this.props.blocTypes,
					this.props.activeUser,
					this.props.history,
					getStateAccessor(this.props)
				);
				this.forceUpdate();
				this.setState({
					startInterventionModalOpenned: false,
				});

				this.displayIntervention();
			} else {
				this.props.getGpsPosition(this.props.authorizedApps);
				this.openStartInterventionModal();
			}
		});
	}

    openStartInterventionModal() {
        this.setState({
            startInterventionModalOpenned: true,
        });
    }

	closeStartInterventionModal() {
		this.setState({
			startInterventionModalOpenned: false,
		});
	}

	pauseInterventionInProgress(startDate, startTime) {
		return new Promise((resolve) => {
			if (this.state.pauseInterventionModalOpenned) return resolve(false);

			getStartedWorkOrder().then((intervention) => {
				if (intervention) {
                    this.props
                    .loadCurrentTimeSlot(intervention.report_block_ids, this.props.blocTypes, this.props.activeUser)
                    .then((timeSlot) => {
                        if (timeSlot) {
                            if (this.state.startInterventionModalOpenned) {
                                let timeSlotToEnd = clone(timeSlot);
                                timeSlotToEnd.endDate = startDate;
                                timeSlotToEnd.endTime = startTime;
                                this.props.pauseIntervention(intervention, timeSlotToEnd,
                                    intervention.report_block_ids, this.props.activeUser,
                                    this.props.blocTypes, this.props.history, getStateAccessor(this.props), false, false)
                                .then(() => {
                                    return resolve(false);
                                })
                                .catch((err) => {
                                    console.error(err);
                                    return resolve(true);
                                });
                            } else {
                                this.setState({
                                    interventionToPause: intervention,
                                    pauseInterventionModalOpenned: true,
                                });

                                return resolve(true);
                            }

                        }
                    });
                } else {
                    return resolve(false);
                }
			});
		});
	}

	closePauseInterventionModal() {
		this.setState({
			pauseInterventionModalOpenned: false,
		});
	}

	openContextMenu() {
		this.setState({ displayContextMenu: true });
	}

	closeContextMenu() {
		this.setState({
			displayContextMenu: false,
			anchorEl: null,
		});
	}

	remove() {
		if (window.confirm("Voulez-vous vraiment supprimer l'OT " + this.props.intervention.name + "?"))
			this.props.removeIntervention(this.props.intervention, this.props.history, this.props.interventionsFilters);

		this.closeContextMenu();
	}

	render() {
		console.perfLog(getCurrentFunctionName());
		let address;
		let city;
		let title = "";
		const { classes } = this.props;

		if (this.props.intervention.delivery_address_id) address = this.props.intervention.delivery_address_id;
		else address = this.props.intervention.delivery_customer_id;

		city = address ? address.city : "";

		if (this.props.intervention.delivery_customer_id && this.props.intervention.delivery_customer_id.customer_code)
			title =
				this.props.intervention.delivery_customer_id.name +
				" [" +
				this.props.intervention.delivery_customer_id.customer_code +
				"]";
		else title = this.props.intervention.comment;

		return (
			<div className="col-lg-4 col-md-4 col-sm-6 col-12 div-card">
				<div ref={(divRef) => (this.divRef = divRef)}>
					<Card className="col-lg-12 col-md-12 col-sm-12 col-12 card list-detail-card card-margin-top without-side-padding">
						<CardContent
							className="without-padding card-content-left-align"
							onClick={this.displayIntervention.bind(this)}
						>
							<div>
								<div className="row">
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 row">
										<div className="without-side-padding blue-text">
											<span className="bold">{title}</span>
											{this.props.intervention.delivery_customer_id &&
												this.props.intervention.delivery_customer_id.customer_code && (
													<span>{", " + city}</span>
												)}
										</div>
									</div>
								</div>
								<div className="row card-body-margin">
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding span-center-verticaly card-div-border-right">
										<div className="span-center">
											<span>
												{this.props.intervention.date_planned_start.format("DD/MM/YYYY")}
											</span>
											<span className="bold">
												{" " + this.props.intervention.date_planned_start.format("HH:mm")}
											</span>
										</div>
									</div>
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding row">
										<div className="span-center bold row">
											<InterventionStatusIcon
												className="without-side-padding"
												state={this.props.intervention.state}
												internalState={this.props.intervention.internalState}
											/>
											<span
												className={
													"status-icon-color-" +
													getColorFromStatusLabel(
														this.props.intervention.state,
														this.props.intervention.internalState
													)
												}
											>
												{formatStatus(
													this.props.intervention.state,
													this.props.intervention.internalState
												)}
											</span>
										</div>
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
										<div className="col-lg-12 col-md-12 col-sm-12 col-12 row card-divider-div"></div>
										<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding span-center-verticaly card-div-border-right">
											<div className="span-center">
												<span>{this.props.intervention.name ? "OT " : ""}</span>
												<span className="bold">
													{this.props.intervention.name ? this.props.intervention.name : ""}
												</span>
											</div>
										</div>
										<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding">
											<div className="span-center bold">
												<span>{this.props.intervention.allocation_label}</span>
											</div>
										</div>
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 row intervention-card-others-div">
										<div className="col-lg-12 col-md-12 col-sm-12 col-12 row card-divider-div"></div>
										<div className="col-lg-2 col-md-2 col-sm-2 col-2">
											<img src={ComponentsParkIcon} alt="" width="18px" height="18px" />
										</div>
										<span>
											{this.props.intervention.equipment_description
												? this.props.intervention.equipment_description
												: ""}
										</span>
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 row intervention-card-others-div">
										<div className="col-lg-12 col-md-12 col-sm-12 col-12 row card-divider-div"></div>
										<div className="col-lg-2 col-md-2 col-sm-2 col-2">
											<Icon color="secondary" className={classes.icon}>
												build
											</Icon>
										</div>
										<span>
											{this.props.intervention.failure_description
												? this.props.intervention.failure_description
												: ""}
										</span>
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-12">
										<div className="col-lg-12 col-md-12 col-sm-12 col-12 row card-divider-div"></div>
										<span className="row intervention-card-technicians-div">
											{this.props.intervention.technician_ids.map((t, i) => {
												let strIntervenant = "";
												let iconElement = null;

												if (!t.name_related) return "";

												if (i !== 0) strIntervenant = strIntervenant.concat(", ");

												if (t.id === this.props.intervention.tec_manager_id.id)
													iconElement = (
														<img src={WorkerIcon} alt="" width="12px" height="12px" />
													);

												strIntervenant = strIntervenant.concat(t.name_related);

												return (
													<div key={i}>
														{strIntervenant}
														{iconElement ? " (" : ""}
														{iconElement}
														{iconElement ? ")" : ""}
													</div>
												);
											})}
										</span>
									</div>
								</div>
							</div>
						</CardContent>
						{this.props.intervention.internalState === "paused" ||
						(!this.props.intervention.internalState &&
							(this.props.intervention.state === "performed" ||
								this.props.intervention.state === "assigned")) ? (
							<CardActions className={classes.cardActions} disableSpacing>
								<Tooltip id="tooltip-icon" title="Démarrer">
									<Button
										variant="contained"
										color="primary"
										className={classes.smallButton}
										onClick={this.start.bind(this)}
									>
										<Icon>play_arrow</Icon>
										Démarrer
									</Button>
								</Tooltip>
								<Tooltip id="tooltip-icon" title="Allons-y">
									<Button
										variant="contained"
										size="small"
										className={classes.btnGo + " " + classes.smallButton}
										onClick={this.launchMaps.bind(this)}
									>
										<Icon>location_on</Icon>
										{"Allons-y"}
									</Button>
								</Tooltip>
							</CardActions>
						) : null}
					</Card>
					<div className="col-lg-12 col-md-12 col-sm-12 col-12">
						<Menu
							id="menu-appbar"
							anchorEl={this.state.anchorEl}
							keepMounted
							className="col-lg-12 col-md-12 col-sm-12 col-12"
							open={this.state.displayContextMenu}
							onClose={this.closeContextMenu.bind(this)}
						>
							<MenuItem onClick={this.remove.bind(this)}>
								<DeleteIcon className="red-icon" />
								Supprimer
							</MenuItem>
						</Menu>
					</div>
					{this.state.startInterventionModalOpenned && (
						<StartInterventionModal
							opened={this.state.startInterventionModalOpenned}
							closeModal={this.closeStartInterventionModal.bind(this)}
							startIntervention={this.start.bind(this)}
							gpsInProgress={this.props.geolocalisationInProgress}
						/>
					)}
					{this.state.pauseInterventionModalOpenned && (
						<InterventionAlreadyInProgressModal
							interventionInProgress={this.state.interventionToPause}
							opened={this.state.pauseInterventionModalOpenned}
							closeModal={this.closePauseInterventionModal.bind(this)}
                            openStartInterventionModal={this.openStartInterventionModal.bind(this)}
						/>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		blocTypes: state.interventions.blocTypes,
		activeUser: state.activeUser,
		currentDay: state.current_day,
		authorizedApps: state.authorizedApps,
		geolocalisationInProgress: state.gpsInformations.geolocalisationInProgress,
		loggedEmployee: state.loggedEmployee.loggedEmployee,
		fluidBottles: state.liquidBottles.myLiquidBottles,
		gpsPosition: state.gpsInformations.gpsPosition,
		interventionsFilters: state.interventions,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		loadIntervention: (intervention) => dispatch(loadIntervention(intervention)),
		loadCurrentTimeSlot: (blocs, blocTypes, user) => dispatch(loadCurrentTimeSlot(blocs, blocTypes, user)),
		getGpsPosition: (authorizedApps) => dispatch(getGpsPosition(authorizedApps)),
		throwWarning: (warnObj) => dispatch(throwWarning(warnObj)),
		gpsPositionError: (authorizedApps, error) => dispatch(gpsPositionError(authorizedApps, error)),
		startIntervention: (intervention, imputationInformations, model, user, history, stateAccessor) =>
			dispatch(startIntervention(intervention, imputationInformations, model, user, history, stateAccessor)),
		removeIntervention: (intervention, history, interventionsFilters) =>
			dispatch(removeIntervention(intervention, history, interventionsFilters)),
         pauseIntervention: (intervention, timeSlot, blocs, user, blocTypes, history, stateAccessor, keepLoading, currentIntervention) =>
            dispatch(pauseIntervention(intervention, timeSlot, blocs, user, blocTypes, history, stateAccessor, keepLoading, currentIntervention)),
	};
};

export default compose(
	withRouter,
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps)
)(InterventionListDetail);
